import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { emmitButtonClick } from 'depop/apps/root/components/HomeAB';
import DownloadLink from './DownloadLink';

import { trackDownLoadAppHeader } from 'depop/utils/tracking';

class DownloadLinkWinAB extends React.Component {
  props: {
    overlays: PropTypes.object,
    onclick: PropTypes.func
  };

  clickDownloadApp = () => {
    const { overlays } = this.props;

    this.winExperiment();
    trackDownLoadAppHeader({source: 'desktop'})
  }

  winExperiment() {
    const { overlays } = this.props;
    const { landingAB } = overlays;

    if (!landingAB) {
      return () => false;
    }

    return emmitButtonClick(landingAB, 'download app');
  }

  render() {
    const { overlays, dispatch, ...props } = this.props;

    return <DownloadLink onclick={() => this.clickDownloadApp()} {...props} />;
  }
}

const mapStateToProps = ({ overlays }) => ({
  overlays,
});

export default connect(mapStateToProps)(DownloadLinkWinAB);



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/DownloadLinkWinAB.js